<template lang="pug">
v-card.mb-3
  v-card-text.pt-1
    v-text-field(label="Suche" :value="$route.query.suche" @input="doSearch" append-outer-icon="search" hide-details)

</template>

<script>
export default {
  props: ['extra'],
  methods: {
    doSearch(search) {
      this.$router.replace({ query: { suche: search } })
    }
  }
}
</script>
